import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import useGlobalStatus from '../../../hook/useGlobalStatus';
import { generateUniqueKey } from '../../../utils/date';
import { MODAL_CONTENT } from '../../../components/modal/constants';
import theme from '../../../theme';

import ChatItem from './ChatItem';
import { ChatListBox, ChatItemBox } from './chatbotStyle';

import { DeleteOutlinedIcon } from '../../../components/customStyles/images';

const ChatList = ({ chatData, progress, scrollToBottom, gptBoxRef, isMoblie }) => {
  const { setIsModalOpen, setModalContent } = useGlobalStatus();

  const handleDeleteChatList = () => {
    setIsModalOpen(true);
    setModalContent(MODAL_CONTENT['deleteChatList']);
  }

  return (
    <>
      <Stack variant='end-center' m={1}>
        <Button
          variant='text-grey-sm'
          disabled={progress}
          onClick={handleDeleteChatList}
          sx={{
            '&:disabled': {
              color: theme.palette.grey.w200,
              backgroundColor: 'inherit',
            }
          }}
        >
          清除紀錄
        </Button>
      </Stack>

      <ChatListBox
        ref={gptBoxRef}
        sx={{
          padding: { xs: '8px 2%', md: '16px 4% 64px 4%' },
          height: isMoblie ? 'calc(100vh - 200px)' : '70vh'
        }}
      >
        <>
          {
            chatData.map((data, index) => {
              return (
                <ChatItemBox
                  key={`${index}_${generateUniqueKey}`}
                  sx={{ fontSize: { xs: '1.125rem', md: '1rem' } }}
                >
                  <ChatItem
                    chatData={data}
                    chatIndex={index}
                    chatLength={chatData.length}
                    progress={progress}
                    isLastIndex={index === chatData.length - 1}
                    scrollToBottom={scrollToBottom}
                  />
                </ChatItemBox>
              )
            })
          }
        </>
      </ChatListBox>
    </>
  )
}

export default ChatList;